export default {
    columns: {
        image: 'Image',
        title: 'Title',
        updatedAt: 'Updated at',
        megaTrends: 'Mega-trends',
        macroTrends: 'Macro-trends',
        trendRadars: 'Trend radars',
        innovationProjects: 'Innovations-projects'
    }
}
